import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import { DEFAULT_LANGUAGE } from '../../constants'
import { getConfig } from '../../config'

export const initI18n = async () => {
  const config = getConfig()

  const supportedLanguages = ['pl', 'en', 'ru', 'uk']

  let savedLanguage = localStorage.getItem('preferredLanguage')

  if (!savedLanguage) {
    let browserLanguage = DEFAULT_LANGUAGE

    if (typeof window !== 'undefined' && window.navigator) {
      browserLanguage = window.navigator.language
    }

    const browserLangCode = (() => {
      if (!browserLanguage) return DEFAULT_LANGUAGE
      const matched = supportedLanguages.find(lang =>
        new RegExp(`\\b${lang}\\b`, 'i').test(browserLanguage)
      )

      if (matched) return matched
      return browserLanguage.split('-')[0] ?? DEFAULT_LANGUAGE
    })()

    const detectedLanguage = supportedLanguages.includes(browserLangCode)
      ? browserLangCode
      : DEFAULT_LANGUAGE

    localStorage.setItem('preferredLanguage', detectedLanguage)
    savedLanguage = detectedLanguage
  }

  await i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: savedLanguage,
      fallbackLng: DEFAULT_LANGUAGE,
      backend: {
        loadPath: `${config.localesPath}/{{lng}}.json`,
      },
      interpolation: {
        escapeValue: false,
      },
    })

  return i18n
}

export default i18n
